import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCalenderTomorrow: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCalenderTomorrow"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V21H3V3ZM19 9H5V19H19V9ZM11.25 10.8358L14.4142 14L11.25 17.1642L9.83579 15.75L11.5858 14L9.83579 12.25L11.25 10.8358Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCalenderTomorrow;
